import React from "react";
import "./CBXInput.css";

export default function CBXInput({
  label,
  type = "text",
  placeholder,
  name,
  value,
  onChange,
}) {
  return (
    <div className="cbx-input-wrapper">
      {label && <label className="cbx-input-label">{label}</label>}

      <input
        className="cbx-input"
        type={type}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        autoComplete="off"
      />
    </div>
  );
}
